<div class="context flex flex-col ml-28">
  <span>{{ getCurrentDate() }}</span>
  <span *ngIf="profile">Bonjour {{profile.firstname}} {{profile.lastname}}</span>
</div>
